import GlobalIcon from '../../assets/icons/3D-Shape-Object.svg';
import DevolucaoIcon from '../../assets/icons/Delivery-Box-Arrows.svg';
import Dollar from '../../assets/icons/Dollar.svg';
import IconEmailSvg from '../../assets/icons/Email.svg';
import GroupUser from '../../assets/icons/Group-User.svg';
import IntegrationsSvg from '../../assets/icons/Integrations.svg';
import LaptopMobile from '../../assets/icons/LaptopMobile.svg';
import SettingsGear from '../../assets/icons/SettingsGear.svg';
import SignOut from '../../assets/icons/Sign-Out.svg';
import IconHomeSVG from '../../assets/icons/Smart-Home.svg';
import UserCircle from '../../assets/icons/User-Profile.9.svg';
import { RoutesMapping } from './routesMapping';

export const buttonsSideBar = [
  {
    id: 'home',
    path: RoutesMapping.HOME,
    label: 'Inicio',
    icon: IconHomeSVG,
    permission: '',
    menu: true,
  },
  {
    id: 'orders',
    path: RoutesMapping.ORDERS,
    label: 'Pedidos/Devoluções',
    icon: DevolucaoIcon,
    permission: '',
    menu: true,
  },
  {
    id: 'pageDevolution',
    path: RoutesMapping.DEVOLUTION_PAGE_COFIGS,
    label: 'Página de Devolução',
    icon: LaptopMobile,
    permission: '',
    menu: true,
  },
  {
    id: 'ruleConfig',
    path: RoutesMapping.CONFIGURATION_RULES,
    label: 'Configurações e Regras',
    icon: SettingsGear,
    permission: '',
    menu: true,
  },
  /*   {
    id: 'zoneDevolution',
    path: '/',
    label: 'Zonas de Devolução',
    icon: GlobalIcon,
    permission: '',
    menu: true,
  }, */
  {
    id: 'emails',
    path: '/emails',
    label: 'Emails',
    icon: IconEmailSvg,
    permission: '',
    menu: true,
  },
  {
    id: 'integrations',
    path: RoutesMapping.INTEGRATIONS,
    label: 'Integrações',
    icon: IntegrationsSvg,
    permission: '',
    menu: true,
  },
];

export const buttonsSideBarProfile = [
  {
    id: 'home',
    path: RoutesMapping.HOME,
    label: 'Inicio',
    icon: IconHomeSVG,
    permission: '',
    menu: true,
  },
  {
    id: 'profile',
    path: RoutesMapping.PROFILE,
    label: 'Minha Conta',
    icon: UserCircle,
    permission: '',
    menu: true,
  },
];

export const ButtonsDropMenu = [
  {
    id: 'profile',
    path: RoutesMapping.PROFILE,
    label: 'Sua conta',
    icon: UserCircle,
    permission: '',
  },
  {
    id: 'Membros',
    path: '/',
    label: 'Membros',
    icon: GroupUser,
    permission: '',
  },
  {
    id: 'Financeiro',
    path: '/',
    label: 'Financeiro',
    icon: Dollar,
    permission: '',
  },
  {
    id: 'logout',
    path: null,
    label: 'Sair',
    icon: SignOut,
    permission: '',
  },
];
